import React, {useEffect, useState} from 'react';
import {UserInfo} from "../types/interfaces";
import {getLoggedInUser} from "../utils/functions";
import {useNavigate} from "react-router-dom";

export const AdminPage: React.FC = () => {
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserInfo = async () => {
            const loggedInUser: UserInfo | null = await getLoggedInUser();
            setUserInfo(loggedInUser);
            if (loggedInUser === null) navigate('/error');
        };
        fetchUserInfo();
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-8">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-2xl font-bold text-center text-green-800 mb-6">Admin Ops</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div
                        className="bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 flex flex-col items-center text-center h-full border border-gray-100 hover:border-blue-300"
                        onClick={() => navigate('/admin/register-user')}
                    >
                        <div className="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-700 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/></svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">Register New User</h2>
                        <p className="text-gray-600 mb-4 flex-grow">Create internal admin users</p>
                        <div className="mt-auto px-4 py-2 bg-blue-50 rounded-full text-sm font-medium text-green-700 border border-blue-200">Open</div>
                    </div>

                    <div
                        className="bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 flex flex-col items-center text-center h-full border border-gray-100 hover:border-blue-300"
                        onClick={() => navigate('/admin/create-agent')}
                    >
                        <div className="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-700 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">Merchant Account</h2>
                        <p className="text-gray-600 mb-4 flex-grow">Create dealer/account</p>
                        <div className="mt-auto px-4 py-2 bg-blue-50 rounded-full text-sm font-medium text-green-700 border border-blue-200">Open</div>
                    </div>

                    <div
                        className="bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 flex flex-col items-center text-center h-full border border-gray-100 hover:border-blue-300"
                        onClick={() => navigate('/admin/delete-kyc')}
                    >
                        <div className="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-700 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 6h18"/>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8 6V4c0-1 1-2 2-2h4c0 1 1 2 1 2v2"/>
                                <line x1="10" y1="11" x2="10" y2="17"/>
                                <line x1="14" y1="11" x2="14" y2="17"/>
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">Delete KYC Number</h2>
                        <p className="text-gray-600 mb-4 flex-grow">Deactivate a phone number</p>
                        <div className="mt-auto px-4 py-2 bg-blue-50 rounded-full text-sm font-medium text-green-700 border border-blue-200">Delete</div>
                    </div>

                    {/* Approve Merchant tile */}
                    <div
                        className="bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 flex flex-col items-center text-center h-full border border-gray-100 hover:border-blue-300"
                        onClick={() => navigate('/admin/approve-merchant')}
                    >
                        <div className="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-700 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75"/></svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">Approve Merchant</h2>
                        <p className="text-gray-600 mb-4 flex-grow">Approve an electricity merchant account</p>
                        <div className="mt-auto px-4 py-2 bg-blue-50 rounded-full text-sm font-medium text-green-700 border border-blue-200">Open</div>
                    </div>

                    <div
                        className="bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 flex flex-col items-center text-center h-full border border-gray-100 hover:border-blue-300"
                        onClick={() => navigate('/admin/reports')}
                    >
                        <div className="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-700 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-6a2 2 0 012-2h2a2 2 0 012 2v6"/><path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10"/></svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">KYC Agent Reports</h2>
                        <p className="text-gray-600 mb-4 flex-grow">View agent verification reports and export data</p>
                        <div className="mt-auto px-4 py-2 bg-blue-50 rounded-full text-sm font-medium text-green-700 border border-blue-200">Open</div>
                    </div>
                </div>
            </div>
        </div>
    );
};